import React from 'react';
import Txt from 'components/atoms/Txt/Txt';
import classes from './PasswordStrengthIndicator.module.scss';
import clsx from 'clsx';

type Props = {
  currentLength: number;
};

const PasswordStrengthIndicator: React.FC<Props> = ({ currentLength = 0 }) => {
  const charactersRequired = 8;
  const indicators = [];

  for (let i = 0; i < charactersRequired; i += 1) {
    const count = i + 1;

    indicators.push(
      <span
        key={i}
        className={clsx(classes.indicator, count > currentLength && classes.indicatorInactive)}
      />,
    );
  }

  return (
    <div className={classes.root}>
      <Txt size="small">Password must be minimum 8 characters</Txt>
      <span className={classes.indicatorContainer}>{indicators}</span>
    </div>
  );
};

export default PasswordStrengthIndicator;
